import axiosInstance from './api';
import {
  normalizePartnerPlansResponse,
  pickPartnerCheckoutUrl,
} from '../utils/partnerSubscriptionPlans';

const getErrorMessage = (error, fallback) => error?.message || error?.error?.message || fallback;

/** GET /admin/plans — partner portal subscription plans for authenticated partner. */
export const listPartnerPlans = async () => {
  try {
    const response = await axiosInstance.get('/admin/plans');
    return {
      success: true,
      data: normalizePartnerPlansResponse(response.data),
      message: response.data?.message || 'Partner subscription plans fetched successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to fetch partner subscription plans'),
      error,
    };
  }
};

/**
 * POST /admin/plans/checkout
 * Body: { planKey, successUrl, cancelUrl, failureUrl }
 */
export const createPartnerPlanCheckout = async ({ planKey, successUrl, cancelUrl, failureUrl }) => {
  try {
    const response = await axiosInstance.post('/admin/plans/checkout', {
      planKey: String(planKey ?? '').trim(),
      successUrl,
      cancelUrl,
      failureUrl,
    });

    const data = response.data?.data ?? response.data;
    const checkoutUrl = pickPartnerCheckoutUrl(response.data);

    return {
      success: true,
      data,
      checkoutUrl,
      message: response.data?.message || 'Checkout session created',
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to start plan checkout'),
      error,
    };
  }
};
